import { Button, Card, Modal, notification } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateLesson } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import { ArrowLeftOutlined } from "@ant-design/icons"
import { useState } from "react"
const AdminAddLesson = ({ open, onClose, onSuccess }) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        CreateLesson(values.title, values.content).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Created Lesson Successfully"
                })
                setLoading(false);
                onSuccess();
                onClose();

            }
        }).catch(err => {
            console.log(err.response.data.message)
            notification.error({
                message: `${err.response.data.message}`
            })
            setLoading(false)
        })
    }


    return (

        <Modal
            open={open}
            title="Create Tool"
            onCancel={onClose}
            footer={[]}
        >
            <Form
                onFinish={onFinish}
                name="wrap"
                labelAlign="left"
                labelWrap
                labelCol={{ flex: '150px' }}
            >  
                    <Form.Item name={"title"} label="Title" rules={[{ required: true, message: 'Requiring title' }]}>
                        <Input
                            placeholder="Input title"
                        />
                    </Form.Item>
                    <Form.Item name={"content"} label="Content" rules={[{ required: true, message: 'Requiring content' }]}>
                        <Input
                            placeholder="Input Content"
                        />
                    </Form.Item>
                    <Form.Item >
                    <Button block type="primary" htmlType="submit" loading={loading}>
                        {loading ? "Loading" : "Save"}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>


    )

}
export default AdminAddLesson